import React, { useState } from 'react';
import Input from '../../components/Input';
import Button from '../../components/Button';
import AuthPage, { AuthLink } from '../../components/AuthPage';
import useAPI from '../../hooks/useAPI';
import useFlash from '../../hooks/useFlash';
import FlashMessage from '../../components/FlashMessage';
import { useFormatter } from '../../hooks/useFormatter';

export default function ResetPassword ({ location }) {
    const query = new URLSearchParams(location.search);

    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [busy, setBusy] = useState(false);
    const [errors, setErrors] = useState({});

    const api = useAPI();
    const formatter = useFormatter();
    const { messages, flash, remove } = useFlash();

    const email = query.get('email');
    const token = query.get('token');

    const resetPassword = (e) => {
        e.preventDefault();

        let _errors = {};
        if( ! password ){
            _errors.password =  "Password required";
        }else if( password.length < 8 ){
            _errors.email = "Passwords must contain at least 8 characters";
        }else if( !/[0-9]+/.test(8) ){
            _errors.email = "Passwords must contain at least 1 number";
        }

        if (!repeatPassword) {
            _errors.repeatPassword = "Repeated password required";
        } else if (repeatPassword !== password) {
            _errors.repeatPassword = "Passwords do not match";
        }

        setErrors(_errors);

        if (Object.keys(_errors).length) {
            return setErrors(_errors);
        }

        setBusy(true);
        api.json('POST', '/auth/reset-password', {
            password,
            email,
            token
        })
            .then(r => r.json())
            .then((response) => {
                if (response.errors) {
                    setBusy(false);

                    let pageError = response.errors.email || response.errors.token;
                    pageError = pageError ? pageError[0] : '';
                    if (pageError) {
                        alert(pageError);
                    }

                    return setErrors({
                        ...errors,
                        ...formatter.flattenErrors(response.errors)
                    });
                }

                flash('Your password has been reset. You can now log in with your new password.', 'success');
                setPassword('');
                setRepeatPassword('');
                setTimeout(() => {
                    window.location = '/login';
                }, 3000);
            })
            .catch((error) => {
                alert(error);
            })
            .then(() => setBusy(false));
    };

    return (
        <AuthPage
            title="Reset your password"
            error={errors.page}
        >
            <div className="row">
                <div className="col-12">
                    <Input
                        error={errors.password || ''}
                        label="New Password"
                        maxLength="40"
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            setErrors({
                                ...errors,
                                password: ''
                            });
                        }}
                        type="password"
                        showToggle
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Input
                        error={errors.repeatPassword || ''}
                        label="Repeat New Password"
                        maxLength="40"
                        value={repeatPassword}
                        onChange={(e) => {
                            setRepeatPassword(e.target.value);
                            setErrors({
                                ...errors,
                                repeatPassword: ''
                            });
                        }}
                        type="password"
                        showToggle
                    />
                </div>
            </div>

            <FlashMessage messages={messages} onRemove={remove} />
            <div className="row">
                <div className="col-12">
                    <Button
                        busy={busy}
                        disabled={busy || !password || !repeatPassword}
                        className="button-full button-primary"
                        onClick={resetPassword}
                    >
                        Reset Password
                    </Button>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <AuthLink to={`/login`}>Nevermind, go back to login</AuthLink>
                </div>
            </div>
        </AuthPage>
    );
};